import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NEWS_FEATURE_KEY, NewsState } from './news.reducer';

export const selectNewsState = createFeatureSelector<NewsState>(NEWS_FEATURE_KEY);

export const selectNews = createSelector(selectNewsState, (state: NewsState) => state.news);

export const selectNewsLoaded = createSelector(selectNewsState, (state: NewsState) => state.loaded);

export const selectNewsError = createSelector(selectNewsState, (state: NewsState) => state.error);
